export const KYC_V2_CONTEXT_KEY = 'kycV2Context';

export const KYC_V2_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  RETRYABLE: 'RETRYABLE'
};

export const KYC_V2_NEXT_ACTION = {
  UPLOAD_DOCUMENT: 'UPLOAD_DOCUMENT',
  OPEN_URL: 'OPEN_URL',
  RUN_SDK: 'RUN_SDK',
  POLL_RESULT: 'POLL_RESULT',
  RETRY: 'RETRY',
  DONE: 'DONE'
};

export function readKycV2Context() {
  try {
    return JSON.parse(sessionStorage.getItem(KYC_V2_CONTEXT_KEY) || '{}');
  } catch (e) {
    return {};
  }
}

export function saveKycV2Context(context = {}) {
  sessionStorage.setItem(KYC_V2_CONTEXT_KEY, JSON.stringify({
    ...readKycV2Context(),
    ...context
  }));
}

export function clearKycV2Context() {
  sessionStorage.removeItem(KYC_V2_CONTEXT_KEY);
}

export function hasKycV2Context() {
  return !!readKycV2Context().sessionId;
}

export function buildKycV2RedirectUrl(path, query = {}) {
  const url = new URL(`${window.location.origin}/rental-h5${path}`);
  Object.keys(query).forEach(key => {
    if (query[key] !== undefined && query[key] !== null && query[key] !== '') {
      url.searchParams.set(key, query[key]);
    }
  });
  url.searchParams.set('kycV2Return', '1');
  return url.toString();
}

export function isKycV2Return(route) {
  return route && route.query && route.query.kycV2Return === '1';
}

export function clearKycV2ReturnQuery(router, route) {
  if (!route || !route.query || !route.query.kycV2Return) return;
  const { kycV2Return, token, ...query } = route.query;
  router.replace({ path: route.path, query });
}

export function toV2AuthResult(view = {}) {
  if (view.verifyResult === 'SUCCESS' || view.status === KYC_V2_STATUS.SUCCESS) return 'SUCCESS';
  if (view.retryable || view.status === KYC_V2_STATUS.RETRYABLE) return 'CAN_RETRY';
  if ([KYC_V2_STATUS.FAILED, KYC_V2_STATUS.CANCELLED, KYC_V2_STATUS.EXPIRED].includes(view.status)) return 'FAIL';
  return '';
}

export function getKycV2LaunchUrl(view = {}) {
  return view.launch && (view.launch.url || view.launch.mockUrl);
}

export async function uploadKycDocumentToOss(uploadInfo, file) {
  const formData = new FormData();
  formData.append('key', uploadInfo.key || uploadInfo.ossKey);
  formData.append('policy', uploadInfo.policy);
  formData.append('OSSAccessKeyId', uploadInfo.OSSAccessKeyId);
  formData.append('signature', uploadInfo.signature);
  formData.append('Content-Type', uploadInfo.contentType);
  formData.append('file', file);

  const response = await fetch(uploadInfo.host, {
    method: 'POST',
    body: formData
  });
  if (!response.ok) {
    throw new Error(`OSS upload failed: ${response.status}`);
  }
}
